<script setup>
import Card from '@/components/Card.vue';
import { storeToRefs } from "pinia";
import { useRecursosDidaticosStore } from "@/store/recursosDidaticosStore";
const store = useRecursosDidaticosStore();
const { avaliacao, gerenciarListaQuestoesVisible } = storeToRefs(store);

function gerenciarListaQuestoes() {
    gerenciarListaQuestoesVisible.value = true
}
</script>

<template>
    <Card @click="gerenciarListaQuestoes" clicavel class="sticky z-5 shadow-1" style="top: 10px">
        <template #conteudo>
            <div class="flex justify-content-between align-items-center ">
                <div class="font-semibold text-color text-lg flex-wrap">
                    {{ avaliacao.titulo }}
                </div>
                <div class="text-color text-sm flex-nowrap">
                    {{ avaliacao.questoes.length }} {{ avaliacao.questoes.length > 1 ? 'questões' : 'questão' }}
                </div>
            </div>
        </template>
    </Card>
</template>